import React, { useState } from 'react';
import { AccordionItem } from './Accordion';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number>(-1);
  const faqs = [{
    q: '¿Sirve si no sé nada de guitarra?',
    a: 'Sí. El sistema empieza desde cero absoluto. El Tomo 1 asume que nunca tocaste una guitarra en tu vida.'
  }, {
    q: '¿Necesito saber leer partitura?',
    a: 'No. Todo se enseña con diagramas de acordes y tablaturas simples, no con partitura clásica.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Acceso inmediato después del pago. Digital — celular, tablet o computadora. También podés imprimirlo.'
  }, {
    q: '¿Qué diferencia hay entre los dos planes?',
    a: 'El Plan Base tiene los 6 tomos y 4 bonos — ideal para aprender desde cero hasta tocar tus primeras canciones. El Plan PRO agrega 3 bonos con contenido intermedio: armonía, fingerstyle y acordes extendidos.'
  }, {
    q: '¿Necesito una guitarra en particular?',
    a: 'No. Funciona con guitarra criolla, clásica o electroacústica. Los ejercicios están pensados para cualquiera de las tres.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días, sin preguntas. Te devolvemos el 100%. Menos del 1% pide devolución.'
  }];
  return <section className="w-full bg-fondo-crema text-fondo-principal py-section px-4" data-id="element-55">
      <h2 className="text-2xl font-bold text-center mb-8" data-id="element-56">
        Preguntas Frecuentes
      </h2>
      <div className="flex flex-col gap-3" data-id="element-57">
        {faqs.map((faq, idx) => <AccordionItem key={idx} variant="cream" isOpen={openIndex === idx} onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)} title={<span className="font-bold text-[15px]" data-id="element-59">{faq.q}</span>} content={<p className="text-gray-700 text-sm" data-id="element-60">{faq.a}</p>} data-id="element-58" />)}
      </div>
    </section>;
}